import { FunctionComponent } from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import SubscriptionAddonInfo from './SubscriptionAddonInfo';
import { useDialog } from '../../../../../common/hooks';
import { appleTvProductId, getProductName } from '../../../constants';

const useStyles = makeStyles(theme => ({
	container: {
		display: 'flex',
		flexDirection: 'column',
	},
	item: {
		marginBottom: theme.spacing(2),
		'&:last-child': {
			marginBottom: 0,
		},
	},
}));

interface SubscriptionAddonAdminProps {
	addonSubscriptions?: Array<{
		productId: number;
		status: string;
		statusChangedAt?: string;
		externalId: string;
		externalUserId: string;
	}>;
	onResendAddonActivationLink: (productId: number) => void;
	onUnlinkAddonSubscription: (productId: number) => void;
}
export const SubscriptionAddonAdmin: FunctionComponent<SubscriptionAddonAdminProps> = ({ addonSubscriptions = [], onResendAddonActivationLink, onUnlinkAddonSubscription }) => {
	const classes = useStyles();
	const [t] = useTranslation();
	const { showDialog } = useDialog() as { showDialog: (config: any) => void };
	const sortedAddons = addonSubscriptions.slice().sort((a, b) => Number(a.productId) - Number(b.productId));

	const handleActivate = (productId: number) => {
		showDialog({
			title: t('common.important'),
			content: <Typography>{t('subscription.subscriptionResendAddonActivationLinkConfirm', { productName: getProductName(productId) })}</Typography>,
			onConfirm: () => onResendAddonActivationLink(productId),
		});
	};

	const handleUnlink = (productId: number) => {
		showDialog({
			title: t('common.important'),
			content: <Typography>{t('subscription.subscriptionUnlinkAddonConfirm', { productName: getProductName(productId) })}</Typography>,
			onConfirm: () => onUnlinkAddonSubscription(productId),
		});
	};

	return (
		<Box className={classes.container}>
			{sortedAddons.map((addonSubscription, index) => (
				<Box
					key={`${addonSubscription.productId}-${addonSubscription.externalId}-${index}`}
					className={classes.item}
				>
					<SubscriptionAddonInfo
						productId={addonSubscription.productId}
						status={addonSubscription.status}
						statusChangedAt={addonSubscription.statusChangedAt}
						externalId={addonSubscription.externalId}
						externalUserId={addonSubscription.externalUserId}
					onActivate={() => handleActivate(addonSubscription.productId)}
					onUnlink={addonSubscription.productId === appleTvProductId ? () => handleUnlink(addonSubscription.productId) : undefined}
					/>
				</Box>
			))}
		</Box>
	);
}

export default SubscriptionAddonAdmin;
